<template>
  <article :id="sectionId" class="dealer-preview section-light">
    <div class="dealer-preview__inner content-width">
      <div class="dealer-preview__visual image-frame" :class="{ 'image-frame--fallback': imageFailed || !dealerImage }">
        <img v-if="dealerImage && !imageFailed" :src="dealerImage" :alt="dealer.name || itemLabel" @error="imageFailed = true">
        <span v-else class="visual-placeholder">{{ imageUnavailableText }}</span>
      </div>
      <div class="dealer-preview__copy">
        <h2>{{ sectionTitle }}</h2>
        <p>{{ copy }}</p>
        <router-link v-if="allLink" :to="allLink" class="button button-dark">{{ buttonText }}</router-link>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'DealerPreview',
  props: {
    dealer: { type: Object, default: null },
    sectionId: { type: String, default: 'dealers' },
    kind: { type: String, default: 'dealer' },
    allLink: { type: String, default: '/dealers' }
  },
  data () { return { imageFailed: false } },
  computed: {
    dealerImage () { return this.dealer && this.dealer.imageUrl },
    isServiceProvider () { return this.kind === 'service' },
    itemLabel () { return this.isServiceProvider ? 'service provider' : 'dealer' },
    // 板块标题用固定的多语言文案，不取后台的名称（对应设计稿的 After-sales Service）
    sectionTitle () { return this.$store.getters.t(this.isServiceProvider ? 'serviceProviderTitle' : 'dealerTitle') },
    imageUnavailableText () { return this.$store.getters.t(this.isServiceProvider ? 'serviceProviderImageUnavailable' : 'dealerImageUnavailable') },
    buttonText () { return this.$store.getters.t(this.isServiceProvider ? 'allServiceCenters' : 'allStores') },
    copy () {
      if (!this.dealer) return this.$store.getters.t(this.isServiceProvider ? 'noServiceProvider' : 'noDealer')
      const description = this.formatMultilineText(this.dealer.description)
      if (this.isServiceProvider) return description || this.$store.getters.t('findServiceProviders')
      if (description) return description
      return [this.dealer.city, this.dealer.address, this.dealer.phone, this.dealer.businessHours]
        .filter(Boolean).join(' | ') || this.$store.getters.t(this.isServiceProvider ? 'findServiceProviders' : 'findDealers')
    }
  },
  watch: {
    dealer () { this.imageFailed = false }
  },
  methods: {
    formatMultilineText (value) {
      return String(value || '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/\\n/g, '\n')
        .replace(/[ \t]+\n/g, '\n')
        .replace(/\n[ \t]+/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
    }
  }
}
</script>
